/* eslint-disable prettier/prettier */
export const MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Member Name",
    key: ["name"],
  },

  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];

export const MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: ["name"],
  },

  {
    displayName: "Div",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
];

export const FD_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Member Name",
    key: ["name"],
  },

  {
    displayName: "Sub Division",
    key: "subdivision",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];

export const FD_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: ["name"],
  },

  {
    displayName: "Sub Div",
    key: "subdivision",
  },
  {
    displayName: "Block",
    key: "block",
  },
];

export const LEADER_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Member Name",
    key: "name",
  },

  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];
export const LEADER_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: "name",
  },

  {
    displayName: "Div",
    key: "division",
  },
  {
    displayName: "Position",
    key: "position",
  },
];
export const FD_LEADER_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Member Name",
    key: "name",
  },
  {
    displayName: "Sub Division",
    key: "subdivision",
  },
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];
export const FD_LEADER_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: "name",
  },
  {
    displayName: "Sub Div",
    key: "subdivision",
  },
  {
    displayName: "Pos",
    key: "position",
  },
];

export const NEW_FRIEND_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Friend Name",
    key: "name",
  },

  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];

export const NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: "name",
  },

  {
    displayName: "Div",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
];

export const FRIEND_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Friend Name",
    key: "name",
  },

  {
    displayName: "Division",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Mtgs",
    key: "count",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];

export const FRIEND_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: "name",
  },

  {
    displayName: "Div",
    key: "division",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Mtgs",
    key: "count",
  },
];

export const FD_NEW_FRIEND_MARK_ATTENDANCE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Friend Name",
    key: "name",
  },

  {
    displayName: "Sub Division",
    key: "subdivision",
  },
  {
    displayName: "Block",
    key: "block",
  },
  {
    displayName: "Attendance",
    key: "attendance",
  },
];

export const FD_NEW_FRIEND_MARK_ATTENDANCE_FOR_MOBILE = [
  {
    displayName: "S.No.",
    key: "sno",
  },
  {
    displayName: "Att",
    key: "attendance",
  },
  {
    displayName: "Name",
    key: "name",
  },

  {
    displayName: "Sub Div",
    key: "subdivision",
  },
  {
    displayName: "Block",
    key: "block",
  },
];

export const ALL_MEMBERS = "All Members";
